export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_FILTER_USER = "SET_FILTER_USER";

export function setUser(data) {
    return {
        type: SET_USER,
        data
    }
}

export function setFilterUser(data) {
    let filters = Object.keys(data);
    if(filters.indexOf("findByCompanyId") !== -1) {
        window.sessionStorage.setItem('findByCompanyId', data.findByCompanyId);
    }
    return {
        type: SET_FILTER_USER,
        data
    }
}

export function setToken(data) {
    return {
        type: SET_TOKEN,
        data
    }
}

